import { createFileRoute } from '@tanstack/react-router';

const SECTIONS = ['workspace', 'ai', 'notifications', 'access', 'workflows', 'audit'] as const;
export type SettingsSection = (typeof SECTIONS)[number];

export const Route = createFileRoute('/settings/')({
  // `?section=access` deep-links a settings tab (e.g. returning from the
  // invite-member page back to Team Members).
  validateSearch: (search: Record<string, unknown>): { section?: SettingsSection } => {
    const section = search.section;
    return SECTIONS.includes(section as SettingsSection)
      ? { section: section as SettingsSection }
      : {};
  },
});
